var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isReviewSubmitted)?_c('ReviewFormPage',{attrs:{"selectedRating":_vm.selectedRating},on:{"submit":_vm.handleSubmit,"close":function($event){return _vm.$emit('close')}}}):_c('ThankYouPage',{attrs:{"review":_vm.submittedReviewData},on:{"close":_vm.handleCloseReview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }